import React, { useState } from "react";

export default function Referrals(props) {
  const [selected, setSelected] = useState([]);

  const options = [
    {
      key: "continuity",
      label: "Continuity of care",
      details: [
        "Your name on all surgical documentation and EMR alerts",
        "Follow-ups scheduled at your office before surgery",
        "No in-house optical → patients return to you"
      ]
    },
    {
      key: "comanagement",
      label: "Clear comanagement",
      details: [
        "Pre-arranged postop visits at your clinic",
        "Direct access anytime",
        "Formal comanagement structure and documentation"
      ]
    },
    {
      key: "speed",
      label: "Fast scheduling & access",
      details: [
        "Dedicated referral scheduling pathway",
        "Direct phone access",
        "Multilingual patient support"
      ]
    },
    {
      key: "communication",
      label: "Strong communication",
      details: [
        "Call/text anytime",
        "Postoperative summary letters"
      ]
    },
    {
      key: "outcomes",
      label: "Excellent outcomes",
      details: [
        "Low complication rates",
        "High patient satisfaction",
        "Advanced technology and lens options"
      ]
    }
  ];

  const toggleSelect = (key) => {
    if (selected.includes(key)) {
      setSelected(selected.filter((k) => k !== key));
    } else {
      setSelected([...selected, key]);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>
          What matters to you when referring a patient?
        </h2>
        <p style={styles.subtitle}>
          Select all that apply. We’ll tailor how we work with you.
        </p>

        <div style={styles.options}>
          {options.map((opt) => {
            const isActive = selected.includes(opt.key);

            return (
              <div
                key={opt.key}
                style={{
                  ...styles.optionCard,
                  border: isActive ? "2px solid #4f46e5" : "1px solid #ddd"
                }}
                onClick={() => toggleSelect(opt.key)}
              >
                <div style={styles.optionHeader}>
                  <span>{opt.label}</span>
                  <span>{isActive ? "✓" : "+"}</span>
                </div>

                {isActive && (
                  <ul style={styles.details}>
                    {opt.details.map((d, i) => (
                      <li key={i}>{d}</li>
                    ))}
                  </ul>
                )}
              </div>
            );
          })}
        </div>

        {selected.length > 0 && (
          <div style={styles.liveSummary}>
            <h3>How we support your preferences:</h3>

            {selected.map((key) => {
              const match = options.find((o) => o.key === key);

              return (
                <div key={key} style={styles.summaryBlock}>
                  <h4>{match.label}</h4>
                  <ul>
                    {match.details.map((d, i) => (
                      <li key={i}>{d}</li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "700px",
    margin: "0 auto",
    padding: "20px"
  },
  card: {
    background: "#fff",
    borderRadius: "16px",
    padding: "30px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
  },
  title: {
    fontSize: "26px",
    marginBottom: "10px",
    textAlign: "center"
  },
  subtitle: {
    textAlign: "center",
    marginBottom: "20px",
    opacity: 0.7
  },
  options: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginBottom: "20px"
  },
  optionCard: {
    borderRadius: "12px",
    padding: "16px",
    cursor: "pointer",
    background: "#fafafa"
  },
  optionHeader: {
    display: "flex",
    justifyContent: "space-between",
    fontWeight: "500"
  },
  details: {
    marginTop: "10px",
    paddingLeft: "18px"
  },
  liveSummary: {
    marginTop: "30px",
    borderTop: "1px solid #eee",
    paddingTop: "20px"
  },
  summaryBlock: {
    marginBottom: "16px"
  }
};
